/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Takes an array of entries and returns an array of unique
 * entries based on the supplied key value for each entry
 */
function uniqueEntriesByKey<
  O extends Record<string, unknown>,
  K extends keyof O,
>(entries: O[], key: K) {
  const map = new Map<unknown, O>();
  entries.forEach((entry) => {
    map.set(entry[key], entry);
  });
  return [...map.values()];
}

export default uniqueEntriesByKey;
